import React from 'react';
import { getSuperPartnerBaseURL } from '@finect/front-utils/env';
import { LazyLoadComponent } from 'react-lazy-load-image-component';
import { Pill } from '../../../Pills';
import { Inner } from './partials';
export var AdvisersCTA = function AdvisersCTA() {
  var stepUrl = "".concat(getSuperPartnerBaseURL(), "/pills/es_ES/finect/default/advisers-leads/advisoryObjective");
  return React.createElement(Inner, null, React.createElement(LazyLoadComponent, null, React.createElement(Pill, {
    pill: stepUrl,
    height: 450,
    onLogin: function onLogin() {
      window.postMessage({
        status: 'loggedIn'
      });
    },
    growOnResize: false
  })));
};